var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","transform":"rotate(-14deg)","top":"-9px","left":"-6px","white-space":"nowrap"}},[_c('span',{staticStyle:{"font-size":"11px","padding":"3px 5px"},style:({
      color: this.fontColor,
      backgroundColor: this.backgroundColor,
      border: ("3px solid " + (this.fontColor)),
    })},[_vm._v("\n    "+_vm._s(_vm.labelText)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }